import MainLayout from "@/components/layout/admin/MainLayout.vue";
import {
    required,
    minLength,
    sameAs
} from "vuelidate/lib/validators";
import axios from "axios";

export default {
    name: "resetPassword",
    components: {
        MainLayout
    },

    data() {
        return {
            password: this.password,
            password_confirmation: this.password_confirmation,
            token: this.$route.query.token,
            submitted: false
        };
    },

    validations: {
        password: {
            required,
            minLength: minLength(6)
        },
        password_confirmation: {
            required,
            sameAsPassword: sameAs("password")
        }
    },

    methods: {
        handleSubmit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.resetPassword();
        },

        resetPassword() {
            var request = {
                password: this.password,
                token: this.token
            };
            axios.post('/admin/reset_password', request)
                .then(response => {
                    console.log("API Success", response.data);
                    this.$notification.success('Password Reset Successfully!', {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                    this.$router.push({
                        name: "adminLogin"
                    });
                })
                .catch(error => {
                    this.$notification.error("Password Reset Failed", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    console.log("Password Reset Client Error", error);
                });
        }
    }
};